"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionHeader = function SectionHeader(props) {
  var children = props.children,
      className = props.className,
      icon = props.icon;

  var rootClassName = (0, _classnames2.default)("erg-components-SectionHeader", "erg-margin-right-10", className);
  return _react2.default.createElement(
    "h2",
    { className: rootClassName },
    icon && _react2.default.createElement(_Icon2.default, {
      className: "erg-margin-right-10",
      icon: icon }),
    children
  );
};

SectionHeader.displayName = "SectionHeader";

SectionHeader.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string
};

exports.default = SectionHeader;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/SectionHeader.js
 ** module id = 391
 ** module chunks = 0
 **/